// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"cdfba654","751":"bd0ecb87"}[chunkId] + ".chunk.js";
};